import React, { useRef } from "react";
import Cropper from "react-easy-crop";
import { useClickOutside } from "../hooks/useClickOutside";

const CropModal = ({
  isOpen,
  rawImage,
  crop,
  zoom,
  rotation,
  onCropChange,
  onZoomChange,
  onRotationChange,
  onCropComplete,
  onClose,
  onConfirm,
  onRetake,
}) => {
  const modalRef = useRef();
  useClickOutside(modalRef, onClose);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center p-4">
      <div ref={modalRef} className="w-full max-w-lg bg-white rounded-[24px] p-4">
        <div className="relative w-full h-96 bg-gray-900 rounded-[24px] overflow-hidden">
          <Cropper
            image={rawImage}
            crop={crop}
            zoom={zoom}
            rotation={rotation}
            onCropChange={onCropChange}
            onZoomChange={onZoomChange}
            onRotationChange={onRotationChange}
            onCropComplete={onCropComplete}
          />
        </div>
        <div className="flex gap-4 mt-4 items-center">
          <button onClick={onRetake} className="w-full border-2 border-primary text-primary py-[14px] rounded-full text-[12px] font-[400]">
            Retake
          </button>
          <button onClick={onConfirm} className=" w-full bg-primary text-white py-4 rounded-full text-[12px] font-[400]">
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
};

export default CropModal;